import { Button, CircularProgress } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import React, { useState } from 'react'
import { getPositionTemplate } from '../api'

interface ButtonDownloadTemplateProps {
  nameFileTemplate: string
  textButtonParam: string
}

export const ButtonDownloadTemplate: React.FC<ButtonDownloadTemplateProps> = ({
  nameFileTemplate,
  textButtonParam = 'Descargar Plantilla'
}) => {
  const [loading, setLoading] = useState<boolean>(false)

  const handleDownloadTemplate = () => {
    setLoading(true)
    getPositionTemplate(nameFileTemplate)
      .then((response) => {
        const { file, mimeType, name } = response.data
        const raw = window.atob(file) // usar file, no response.data
        const uInt8Array = new Uint8Array(raw.length)
        for (let i = 0; i < raw.length; ++i) {
          uInt8Array[i] = raw.charCodeAt(i)
        }

        const blob = new Blob([uInt8Array], { type: mimeType }) // mimeType
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
      })
      .catch((message: any) => {
        console.log('message: ', message)
      }).finally(() => setLoading(false))
  }

  return (
    <Button
      variant='outlined'
      disabled={loading}
      onClick={handleDownloadTemplate}
      startIcon={loading ? <CircularProgress size='0.9rem' /> : <FileDownloadOutlinedIcon />}
    >
      {loading ? 'Descargando...' : textButtonParam}
    </Button>
  )
}
